import React from 'react'
import d10 from './DropUpMenu.module.css'

function DropUpMenu(props) {
    return (
        <div>
          <div id={props.opened?d10.openBackdrop:d10.close} onClick={()=>props.close()} className={d10.backDrop}></div>
              <div id={props.opened?d10.open:d10.close} className={d10.dropdown}>
                {props.children}   
              </div>  
        </div>
    )
}

export default DropUpMenu
